import HorseAvatar from './HorseAvatar';

export default HorseAvatar;